import { render } from "./Reservas.vue?vue&type=template&id=d5c3d704&scoped=true"
import script from "./Reservas.vue?vue&type=script&lang=js"
export * from "./Reservas.vue?vue&type=script&lang=js"

import "./Reservas.vue?vue&type=style&index=0&id=d5c3d704&scoped=true&lang=css"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5c3d704"]])

export default __exports__